import { extendObservable } from 'mobx';

class BannerStore {
  constructor(props) {
    let showBanner = true;
    if (
      sessionStorage.getItem('showAlertBanner-' + props.session_key) === 'false'
    ) {
      showBanner = false;
    }
    extendObservable(this, {
      bannerText: props.banner_text || '',
      url: props.link_url || '#',
      urlText: props.link_text || '',
      showBanner: showBanner,
      context: props.session_key,
    });
  }

  closeBanner = () => {
    this.showBanner = false;
    sessionStorage.setItem('showAlertBanner-' + this.context, 'false');
  };
}

export default BannerStore;
